var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchCheckChecked3Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 969.4 999",
    style: {
      enableBackground: "new 0 0 969.4 999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#484C51;enable-background:new    ;}\n\t.st1{fill:#00C213;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443,999c-59.8,0-117.8-11.7-172.5-34.8c-52.8-22.3-100.1-54.3-140.8-94.9c-40.7-40.7-72.6-88-94.9-140.8 C11.7,673.8,0,615.8,0,556s11.7-117.8,34.8-172.4c22.3-52.8,54.3-100.1,94.9-140.8c40.7-40.7,88-72.6,140.8-94.9 C325.2,124.7,383.2,113,443,113s117.8,11.7,172.4,34.8c52.8,22.3,100.1,54.2,140.8,94.9s72.6,88,94.9,140.8 C874.3,438.2,886,496.2,886,556s-11.7,117.8-34.8,172.5c-22.3,52.8-54.3,100.1-94.9,140.8c-40.7,40.7-88,72.6-140.8,94.9 C560.8,987.3,502.8,999,443,999z M443,203c-94.3,0-182.9,36.7-249.6,103.4S90,461.7,90,556s36.7,182.9,103.4,249.6 S348.7,909,443,909s182.9-36.7,249.6-103.4S796,650.3,796,556s-36.7-182.9-103.4-249.6S537.3,203,443,203z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.7,771.8C322.1,637.9,167,584.9,165.7,584l106.2-169.2c5.2,3.4,97.2,64.4,180.6,166 C558,316.1,765.5,53.8,827.6,0l141.8,143.6C730.1,350.9,535,764.7,533,768.8L391.7,771.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchCheckChecked3Dark);
export default __webpack_public_path__ + "static/media/ach_check-checked-3-dark.993595ba68a5ceacd7ac8caded1a4e29.svg";
export { ForwardRef as ReactComponent };